import { StorageMap } from '@ngx-pwa/local-storage';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class I18nService {
    private httpClient: HttpClient;
    private modules: string[] = [];

    constructor(
        handler: HttpBackend,
        private storage: StorageMap,
        private translate: TranslateService,
    ) {
        this.httpClient = new HttpClient(handler);
        this.translate.onLangChange.subscribe(() => {
            this.storage.set('language', this.translate.currentLang).subscribe();
            this.modules.forEach(name => {
                this.getTranslations(`assets/i18n/${name}/${this.translate.currentLang}.json`);
            });
        });
    }

    private getTranslations(path: string): void {
        this.httpClient.get(path).subscribe(translations => {
            this.translate.setTranslation(this.translate.currentLang, translations, true);
        });
    }

    public registerModule(name: string): void {
        if (this.modules.includes(name)) { return; }
        this.modules.push(name);
        this.getTranslations(`assets/i18n/${name}/${this.translate.currentLang}.json`);
    }

}
